import React from 'react';
import { useNavigate } from 'react-router-dom';

// JSON-like slide data
const slideData = [
  {
    id: 1,
    backgroundImageUrl: '/hero-bg.svg',
    heading: <>One-Stop for All <br /> Your <br />  Tech Solutions.</>,
  
    paragraph: 'Innovative, scalable, and future-ready solutions designed to elevate your business in the digital era.',
    buttonText: 'Get in Touch',
  },
  // Add more slides here if needed
];

const Hero = () => {
  const navigate = useNavigate();
  const slide = slideData[0]; // Show only the first slide

  const handleButtonClick = (buttonText) => {
    if (buttonText === "Get in Touch") {
      navigate("/contact");
    } else if (buttonText === "Explore More") {
      navigate("/about");
    }
  };

  return (
   <section
  id="hero"
  className="relative w-full h-[75vh] sm:h-[80vh] lg:h-[87vh]"
  style={{
    backgroundImage: `url(${slide.backgroundImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-65"></div>

  {/* Content */}
  <div className="relative z-10 flex h-full w-full items-center justify-center px-4 sm:px-6 md:px-8">
    <div className="w-full max-w-6xl text-white text-center">
      <h1 className="mb-6 text-[36px] sm:text-[48px] md:text-[54px] lg:text-[60px] font-bold leading-[1.2]">
        {slide.heading}
      </h1>
      <p className="mb-8 text-[16px] sm:text-[17px] md:text-[18px] text-gray-200 mx-auto max-w-3xl">
        {slide.paragraph}
      </p>
      <button
        className="transform rounded-md bg-gradient-to-r from-brand-yellow to-brand-pink px-7 py-3 sm:px-9 sm:py-4 font-semibold text-white transition duration-300 ease-in-out hover:opacity-90 hover:scale-110"
        onClick={() => handleButtonClick(slide.buttonText)}
      >
        {slide.buttonText}
      </button>
    </div>
  </div>
</section>

  );
};

export default Hero;
